'use strict';

const Analytics = require('./analytics');

var checkoutStages = [
    'cart',
    'shipping',
    'payment',
    'placeOrder',
    'submitted'
];
var paymentMap = {
    'CREDIT_CARD': 'Credit Card',
    'CREDIT_CARD_AMEX': 'American Express',
    'BML': 'Bill me Later',
    'MYBANK': 'My Bank',
    'PayPal': 'PayPal',
    'S2PALI': 'Alipay',
    'S2PIDE': 'iDeal',
    'S2PKLA': 'Klarna',
    'KLARNA': 'Klarna',
    'S2PSOF': 'Sofort',
    'SOFORT': 'Sofort',
    'COD': 'cash_on_delivery',
    'CONTRASSEGNO': 'cash_on_delivery',
    'IDEAL': 'Ideal',
    'GIFT_CARD': 'gift_card',
    'S2PCRU': 'Cards_Russia',
    'S2PMUL': 'Multibanco',
    'MULTIBANCO': 'Multibanco',
    'PRZELEWY24': 'Przelewy24',
    'PAYPO': 'PayPo',
    'BLIK': 'Blik',
    'DW_APPLE_PAY': 'ApplePay',
    'ScalaPay': 'ScalaPay',
    'MBWAY': 'MB Way',
    'PORTMONE': 'Portmone',
    'PAYBYLINK': 'pay_with_link',
    'GOOGLEPAY': 'google_pay',
    'AMAZONPAY': 'amazon_pay',
    'PAYGINE': 'paygine',
    'BIZUM': 'bizum',
    'DIGITAL_WALLET': 'tezenis_wallet'
};

const stageEventMap = {
    2: 'view_cart',
    3: 'add_shipping_info',
    4: 'add_payment_info'
};

function getCurrentStage () {
    let container = $('#checkout-main');
    let confirmContainer = $('.analytics.checkout.stage.confirm');
    if (confirmContainer.length > 0) {
        return 6;
    }
    if (container.length === 0) {
        return 2;
    }
    return checkoutStages.indexOf(container.data('checkout-stage')) + 1;
}

function getPaymentMethod (rawMethod) {
    let mapped = paymentMap[rawMethod];
    if (mapped) {
        return mapped;
    }
    return 'other';
}

function isCheckoutFunnel () {
    let link = window.location.href.toLowerCase();
    return (link.indexOf('cart') !== -1) || (link.indexOf('checkout') !== -1) || (link.indexOf('confirmation') !== -1);
}

function isCart () {
    return window.location.href.toLowerCase().indexOf('cart') !== -1;
}

function isShipping () {
    if ($('.data-checkout-stage').attr('data-checkout-stage') && $('.data-checkout-stage').attr('data-checkout-stage').length > 0) {
        return $('.data-checkout-stage').attr('data-checkout-stage') === 'shipping';
    } else {
        return false;
    }
}

function isPayment () {
    return window.location.href.toLowerCase().indexOf('payment') !== -1;
}

function isGiftStage () {
    return window.location.href.toLowerCase().indexOf('gift') !== -1;
}

function pushChangeStep (step) {
    if (dataLayer && dataLayer[0]) {
        var wSetupEvent = dataLayer[0];
        wSetupEvent.pageTemplate = (step === 'funnel_step4' ? 'funnel_step3' : step);
        dataLayer.push(wSetupEvent);
    }
}
class CheckoutFunnel extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'CheckoutFunnel';

        if (isCheckoutFunnel()) {
            super.init(globalContainer, helperContainer);
            this.pushLandingInteraction();
            this.prepareObservers();
            this.prepareCartInteractionObservers();
        }
    }

    getProductList () {
        let items = [];
        let container = $('.analytics.checkout.checkout-product');

        for (let i = 0; i < container.length; i++) {
            let obj = container.eq(i).data();

            // Fix values for MEC-30160
            if (obj.item_list_name === 'not_available') {
                obj.item_list_name = 'listing';
            }

            if (obj.item_list_id === 'not_available') {
                obj.item_list_id = 'pdp';
            }

            obj['quantity'] = obj.quantity;
            obj['index'] = i;
            if (localStorage.getItem('visualizationTypeProduct' + container.eq(i).attr('data-item_id'))) {
                container.eq(i).attr('data-visualization_type', localStorage.getItem('visualizationTypeProduct' + container.eq(i).attr('data-item_id')));
                container.eq(i).data('visualization_type', localStorage.getItem('visualizationTypeProduct' + container.eq(i).attr('data-item_id')));
            }
            items.push(this.helper.formatProductForAnalytics(obj));
        }
        return items;
    }

    getDisountsList () {
        let discounts = $('.order-total-summary .analytics-checkout-discount-applied');
        let types = '';

        for (let i = 0; i < discounts.length; i++) {
            types = types === '' ? discounts.eq(i).data('promo-type') : types + '-' + discounts.eq(i).data('promo-type');
        }
        return types.toLowerCase();
    }

    pushFinalStage (stage) {
        let link = window.location.href.toLowerCase();
        if (stage !== 6) {
            return;
        }
        if (link.indexOf('confirmation') == -1) {
            return;
        }
        let container = $('.analytics.checkout.stage.confirm');
        let products = this.getProductList();
        let giftkitCard = $('.analytics-giftkit-order-data').eq(0);
        let giftkitCardQuantity = $('.analytics-giftkit-order-data').data('quantity');
        let giftkitTotal = giftkitCardQuantity > 0 ? parseFloat(giftkitCardQuantity) * parseFloat(giftkitCard.data('price')) : 0;
        container.data('costGiftWrapKit', parseFloat(giftkitTotal));
        let extrascost = '';
        if (giftkitTotal) extrascost += 'cost_of_gift_kit ';
        if (container.data('costGiftPack')) extrascost += 'cost_of_gift_wrapping ';
        if (container.data('costCustomization')) extrascost += 'cost_of_personalization ';
        if (container.data('costCashOnDelivery')) extrascost += 'cost_of_cash_on_delivery ';
        extrascost = extrascost.trim().trim().replace(/ /g, '-');
        container.data('extraCostType', extrascost);

        if (products.length === 0) {
            return;
        }

        let actualPaymentMethod = $('.analytics.checkout.stage.confirm').data('payment_type');
        let paymentSummary = $('.payment-details').text();
        if (actualPaymentMethod !== 'gift_card' && localStorage.getItem('giftCardApplied') === 'true') {
            if (paymentSummary.indexOf('Gift Card') !== -1) {
                $('.analytics.checkout.stage.confirm').data('payment_type', 'gift_card_' + actualPaymentMethod);
            } else if (paymentSummary.indexOf('Reso Card') !== -1) {
                $('.analytics.checkout.stage.confirm').data('payment_type', 'reso_card_' + actualPaymentMethod);
            }
        } else if (actualPaymentMethod === 'gift_card' && paymentSummary.indexOf('Reso Card') !== -1) {
            $('.analytics.checkout.stage.confirm').data('payment_type', 'reso_card');
        }

        if (actualPaymentMethod !== 'tezenis_wallet' && localStorage.getItem('digitalWalletApplied') === 'true') {
            $('.analytics.checkout.stage.confirm').data('payment_type', 'tezenis_wallet_' + actualPaymentMethod);
        }

        if (actualPaymentMethod === 'klarna_payments') {
            let savedKlarna = localStorage.getItem('paymentMethodKlarna');
            if (!savedKlarna) {
                var selectedPaymentMethodMapped = $('.drawer:not(.hidden):not(.giftCardDrawer):not(.digitalWalletDrawer).active').data('analytics-method');
                $('.analytics.checkout.stage.confirm').data('payment_type', selectedPaymentMethodMapped);
            } else {
                $('.analytics.checkout.stage.confirm').data('payment_type', savedKlarna);
            }
        }
        let giftwrappedProducts = localStorage.getItem('giftwrappedProducts') ? localStorage.getItem('giftwrappedProducts').split('-').map((e) => {
            return this.helper.getFormatSku(e);
        }) : [];

        container.data('shipping', parseFloat(container.data('shipping')));
        container.data('couponValue', parseFloat(container.data('couponValue')));
        container.data('value', parseFloat(container.data('value')));

        let pushObject = {
            'event': 'purchase',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'upselling_message': this.helper.getUpsellingMessage(),
            'ecommerce': {
                'currency': this.helperData.currency,
                ...container.data(),
                'items': products.map((e, index) => {
                    let epid = this.helper.getFormatSku(e.item_sfcc);
                    e.index = index;
                    if (giftwrappedProducts && giftwrappedProducts.indexOf(epid) > -1) {
                        e['item_gift_pack'] = 'yes';
                        giftwrappedProducts[giftwrappedProducts.indexOf(epid)] = '';
                    } else {
                        e['item_gift_pack'] = 'no';
                    }
                    return e;
                })
            }
        };

        this.log('Pushing checkout impression for final stage!', true);

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushForStage (stage) {
        if (localStorage.getItem('from-gift-option') && localStorage.getItem('from-gift-option') === 'true') {
            localStorage.setItem('from-gift-option', false);
            return;
        }
        if (stage > 5) {
            if (localStorage.getItem('stageTwoFired') === 'false') { // case of fast checkout and redirect to confirmation page
                this.pushForStage(3);
                this.pushForStage(4);
                localStorage.setItem('stageTwoFired', true);
            }
            this.pushFinalStage(stage);
            localStorage.setItem('stepFourFired', '');
            return;
        }
        let products = this.getProductList();

        if (products.length === 0) {
            return;
        }
        let pushObject = {};
        if (stage !== 4) {
            pushObject = {
                'event': stageEventMap[stage],
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'upselling_message': this.helper.getUpsellingMessage(),
                'ecommerce': {
                    'currency': this.helperData.currency,
                    'value': this.helper.getGrandTotal(),
                    'items': products
                }
            };
        } else {
            let giftwrappedProducts = localStorage.getItem('giftwrappedProducts') ? localStorage.getItem('giftwrappedProducts').split('-').map((e) => {
                return this.helper.getFormatSku(e);
            }) : [];
            pushObject = {
                'event': stageEventMap[stage],
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'upselling_message': this.helper.getUpsellingMessage(),
                'ecommerce': {
                    'currency': this.helperData.currency,
                    'value': this.helper.getGrandTotal(),
                    'items': products.map((e) => {
                        let epid = this.helper.getFormatSku(e.item_sfcc);
                        if (giftwrappedProducts && giftwrappedProducts.indexOf(epid) > -1) {
                            e['item_gift_pack'] = 'yes';
                            giftwrappedProducts[giftwrappedProducts.indexOf(epid)] = '';
                        } else {
                            e['item_gift_pack'] = 'no';
                        }
                        return e;
                    })
                }
            };
        }

        let storageSelectedPaymentMethod = localStorage.getItem('selectedPaymentMethod');
        let selectedPaymentMethodId = $('.drawer:not(.hidden):not(.giftCardDrawer):not(.digitalWalletDrawer).active').data('method-id');
        if (selectedPaymentMethodId && !storageSelectedPaymentMethod) {
            localStorage.setItem('selectedPaymentMethod', selectedPaymentMethodId);
        }

        if (stage === 2) {
            if (document.location.href.indexOf('checkout') === -1) {
                this.push({ecommerce: null});
                this.push(pushObject);
                localStorage.setItem('stageTwoFired', false);
            }
        } else if (stage === 3) {
            // Shipping
            let selectedShippingMethod = $('.shipping-method-type').text() || localStorage.getItem('selectedShippingMethod') || 'home_standard';
            pushObject.ecommerce.currency = this.helperData.currency;
            pushObject.ecommerce.shipping_tier = selectedShippingMethod;
            pushObject.ecommerce.coupon = this.helper.getAppliedCoupon();
            this.push({ecommerce: null});
            this.push(pushObject);
            localStorage.setItem('stageTwoFired', true);
            localStorage.setItem('giftCardApplied', 'false');
        } else if (stage === 4) {
            // Payment
            let giftcardActive = $('.giftCardDrawer:not(.hidden).active').data('method-id');
            let digitalWalletActive = localStorage.getItem('digitalWalletApplied') === 'true';
            let digitalWalletFullPayment = localStorage.getItem('digitalWalletFullPayment') === 'true';
            let selectedPaymentMethod = $('.drawer:not(.hidden):not(.giftCardDrawer):not(.digitalWalletDrawer).active').data('method-id');
            if (!selectedPaymentMethod && $('.payment-summary').find('.paypal-method-name').length > 0) {
                selectedPaymentMethod = 'PayPal';
            }
            if (!selectedPaymentMethod) {
                selectedPaymentMethod = digitalWalletActive && digitalWalletFullPayment ? '' : localStorage.getItem('selectedPaymentMethod'); // for express checkout
            }
            let selectedPaymentMethodMapped = getPaymentMethod(selectedPaymentMethod);
            if (giftcardActive) {
                selectedPaymentMethodMapped = getPaymentMethod(giftcardActive) + '_' + selectedPaymentMethodMapped;
            }
            if (digitalWalletActive) {
                let digitalWalletPaymentMethodMapped = localStorage.getItem('digitalWalletPaymentMethodMapped');
                if (digitalWalletPaymentMethodMapped) {
                    selectedPaymentMethodMapped = digitalWalletPaymentMethodMapped;
                } else {
                    selectedPaymentMethodMapped = selectedPaymentMethodMapped.indexOf('other') === -1 ?
                        getPaymentMethod('DIGITAL_WALLET') + '_' + selectedPaymentMethodMapped :
                        getPaymentMethod('DIGITAL_WALLET');
                    localStorage.setItem('digitalWalletPaymentMethodMapped', selectedPaymentMethodMapped);
                }
            }
            if (selectedPaymentMethod === 'KLARNA_PAYMENTS') {
                selectedPaymentMethodMapped = $('.drawer:not(.hidden):not(.giftCardDrawer):not(.digitalWalletDrawer).active').data('analytics-method');
                localStorage.setItem('paymentMethodKlarna', selectedPaymentMethodMapped);
            }

            pushObject.ecommerce.currency = this.helperData.currency;
            pushObject.ecommerce.payment_type = this.helper.formatString(selectedPaymentMethodMapped);
            pushObject.ecommerce.coupon = this.helper.getAppliedCoupon();
            if (localStorage.getItem('stageTwoFired') === 'true') {
                this.push({ecommerce: null});
                this.push(pushObject);
            }
        }

        this.log('Pushing checkout impression for step: ' + stage, true);
    }

    pushLandingInteraction () {
        let stage = getCurrentStage();
        this.pushForStage(stage);
    }

    handleNextStage (data) {
        // Leave the increment just in case another function should be used instead
        let stage = 0;
        if (data.stage === 4) {
            stage = data.stage;
        } else {
            stage = data.stage + 1;
        }
        if (stage > 1) {
            this.pushForStage(stage);
        }
    }

    handleAddressInteraction (data) {
        if (!data) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '60',
            'eventname': 'shipping_address',
            'action': data.eventAction,
            'step': 'step_1',
            'position': data.eventAction
        };

        this.push(pushObject);
    }

    pushSubmitUpdateAddressInteraction (eventAction) {
        if (!eventAction) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '61',
            'eventname': 'shipping_address',
            'action': eventAction,
            'step': 'step2'
        };
        this.push(pushObject);
    }

    changeCountryInCheckout (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '91',
            'eventname': 'change_country',
            'action': data.newCountry,
            'type': data.previousCountry,
            'position': 'checkout'
        };
        this.push(pushObject);
    }

    confirmChangeCountryInCheckout (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '92',
            'eventname': 'change_country',
            'action': data.action,
            'type': data.newCountry + '-' + data.previousCountry,
            'position': 'checkout'
        };
        this.push(pushObject);
    }

    applyGiftWrapOrPaper (action, topic) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '130',
            'eventname': 'gift_options',
            'action': action,
            'area': topic
        };
        this.push(pushObject);
    }

    pushFindStoreClickResultAction (action, store, sku, when) {
        if (!store) { // TODO - Prevent from triggering with empty store
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '119',
            'eventname': 'store_locator_page_details',
            'action': action,
            'store': store,
            'product_id': sku,
            'type': when
        };

        this.push(pushObject);
    }

    pushFindStoreCheckout (store, sku, when) {
        if (!store) { // TODO - Prevent from triggering with empty store
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '24',
            'eventname': 'store_locator_search',
            'action': 'search',
            'search_term': store,
            'product_id': sku,
            'type': when
        };

        this.push(pushObject);
    }

    pushNewsletterPreference (marketingAgreement = false, profilingAgreement = false) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '150',
            'eventname': 'privacy_consent',
            'action': 'change_preferences',
            'position': 'checkout',
            'label': 'tzn',
            'privacy_news': marketingAgreement ? 'on-news_and_promotions' : 'off-news_and_promotions',
            'privacy_custom_news': profilingAgreement ? 'on-custom_news_and_promotions' : 'off-custom_news_and_promotion'
        };

        this.push(pushObject);
    }

    prepareObservers () {
        var _self = this;

        $('body').on('checkout:pushNewsletterPreference', function (e, data) {
            _self.pushNewsletterPreference(data.marketingAgreement, data.profilingAgreement);
        });
        $('body').on('checkout:afterHandleNextStage', function (e, data) {
            _self.handleNextStage(data);
        });
        $('body').on('checkout:addressInteration', function (e, data) {
            localStorage.setItem('lastAction', data.eventAction);
            pushChangeStep('funnel_step2');
            _self.handleAddressInteraction(data);
        });
        $('body').on('checkout:giftInteration', function (e, data) {
            localStorage.setItem('lastAction', data.eventAction);
            pushChangeStep('funnel_step3');
            _self.handleAddressInteraction(data);
        });
        $('body').on('address:submitFromCheckout', function (e, data) {
            let lastAction = localStorage.getItem('lastAction');
            pushChangeStep('funnel_step3');
            _self.pushSubmitUpdateAddressInteraction(lastAction);
            if (lastAction) {
                localStorage.setItem('lastAction', '');
            }
        });
        $('body').on('click', '.edit-button', function (e, data) {
            pushChangeStep('funnel_step1');
            _self.handleAddressInteraction(data);
        });

        $('body').on('checkout:changeCountry', function (e, data) {
            if (data.action) {
                _self.confirmChangeCountryInCheckout(data);
            } else {
                _self.changeCountryInCheckout(data);
            }
        });
        $('body').on('click', '.button.open-gift-wrap', function (e, data) {
            _self.applyGiftWrapOrPaper('add_the_gift_wrap', 'gift_wrap');
        });
        $('body').on('click', '.js-wrap-links .open-gift-wrap', function (e, data) {
            _self.applyGiftWrapOrPaper('change_the_gift_wrap', 'gift_wrap');
        });
        $('body').on('click', '.js-wrap-links .remove-gift-wrap', function (e, data) {
            _self.applyGiftWrapOrPaper('remove_the_gift_wrap', 'gift_wrap');
        });
        $('body').on('click', '.button.open-gift-kit', function (e, data) {
            _self.applyGiftWrapOrPaper('add_the_self_gift', 'self_gift');
        });
        $('body').on('click', '.js-kit-links .open-gift-kit', function (e, data) {
            _self.applyGiftWrapOrPaper('change_the_self_gift', 'self_gift');
        });
        $('body').on('click', '.js-kit-links .remove-gift-kit', function (e, data) {
            _self.applyGiftWrapOrPaper('remove_the_self_gift', 'self_gift');
        });
        $('body').on('gift-wrap-product-saved', function (e, data) {
            let productsname = data.productsname.split('-').map((e) => {
                return _self.helper.formatString(e);
            }).join('-');
            _self.helper.formatString(data.productsname);
            let skus = data.skus.split('-').map((e) => {
                return _self.helper.getFormatSku(e);
            }).join('-');
            _self.quickImpressionSender.pushProductsInsideGiftWrap(productsname, skus);
        });
        $('body').on('gift-kit-added', function (e, data) {
            _self.quickImpressionSender.pushGiftKit(data.quantity);
        });
        $('body').on('mouseenter', '.analytics-shipping-info-bag', function (e) {
            _self.quickImpressionSender.pushShippingMoreInfo('shipping_cost');
        });
        $('body').on('mouseenter', '.analytics-estimated-info-bag', function (e) {
            _self.quickImpressionSender.pushShippingMoreInfo('shipping_method');
        });
        $('.analytics-customization-return-info').on('mouseover', function (e) {
            _self.quickImpressionSender.pushShippingMoreInfo('return_and_shipping_customized_product');
        });
        $('body').on('analytics:order_review_proceed', function (e, data) {
            _self.quickImpressionSender.pushOrderReviewProceed();
        });
        $('body').on('click', '.checkout-product-summary a', function (e, data) {
            if (!$(this).closest('.checkout-product-summary').hasClass('active')) {
                let where = isCart() ? 'from_cart' : (isShipping() ? 'from_shipping_page' : (isPayment() ? 'from_payment_page' : (isGiftStage() ? 'from_gift_page' : 'from_thankyou_page')));
                _self.quickImpressionSender.pushOrderReview('open_accordion', where);
            }
        });
        $('body').on('click', '.order-items-summary .edit-button', function (e, data) {
            let where = isCart() ? 'from_cart' : (isShipping() ? 'from_shipping_page' : 'from_payment_page');
            _self.quickImpressionSender.pushOrderReview('change', where);
        });
        $('body').on('mouseenter', '.save-credit-card .info-icon', function (e) {
            _self.quickImpressionSender.pushPaymentMoreInfo();
        });
        $('body').on('checkout:geolocationSucceeded', function (e, data) {
            if (!isCheckoutFunnel()) {
                return;
            }
            let sku = $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-');
            let where = $('.js-store-city').eq(0).html();
            if (!where) {
                where = $('#input-text-woosmap-findinstore').val().split(',')[0];
            }
            _self.pushFindStoreClickResultAction('geolocalize', where, sku, 'shipping_method');
        });
        $('body').on('storeLocator:searchWithZipCodeGeoCheckoutCity', function (e, data) {
            if (!isCheckoutFunnel() && data.event !== 'store_locator') {
                return;
            }
            let name = _self.helper.formatString(data.name);
            let sku = $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-');
            _self.pushFindStoreCheckout(name, sku, 'shipping_method');
        });

        $('body').on('analytics:clickonBlackMarker', function (e, data) {
            let action = 'view_in_map';
            let storeName = data.name;
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let availability = '';
            $('.checkout-product-summary .checkout-product').each(function (e, item) {
                availability = availability === '' ? $(item).data('dimension38') : availability + '-' + $(item).data('dimension38');
            });
            _self.pushFindStoreClickResultAction(action, storeName, sku, 'shipping_method');
        });
    }

    // Cart Interactions
    prepareCartInteractionObservers () {
        let _self = this;

        $('#checkout-button-secure-checkout').on('click', function (e) {
            _self.quickImpressionSender.pushBeginCheckout(_self.helper.getBeginCheckoutData(_self));
        });

        $('body').on('analytics:paypal', function (e) {
            localStorage.setItem('selectedPaymentMethod', 'PayPal');
            if (isCart() || isShipping()) {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction('pay_with_paypal', 'from_popup');
            } else {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction('pay_with_paypal', 'from_payment_page');
            }
        });

        $('body').on('analytics:applepay', function (e) {
            if (isCart() || isShipping()) {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction('pay_with_applepay', 'from_popup');
            } else {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction('pay_with_applepay', 'from_payment_page');
            }
        });
        $('body').on('analytics:fakeExpressButton', function (e, data) {
            if (isCart()) {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction(data.type, 'from_cart');
            } else {
                _self.quickImpressionSender.pushCheckoutButtonsFromCartInteraction(data.type, 'from_shipping_page');
            }
        });
        $('body').on('analytics:fastCheckoutShippingMethod', function (e, data) {
            let type = data.type;
            let name = data.name ? data.name.trim() : '';
            let user = 'guest';
            if (_self.helperData.frequentlyUser) {
                user = 'frequently_user';
            }
            _self.quickImpressionSender.pushFastShippingMethodClickInteraction(type, user, _self.helper.formatString(name));
        });
        $('body').on('analytics:paymentFastCheckout', function (e, data) {
            let method = data.method;
            let user = 'guest';
            if (_self.helperData.frequentlyUser) {
                user = 'frequently_user';
            }
            let shippingType = 'home_standard';
            if ($('.card.shipping-recap').find('.selectedStoreRecap').css('display') !== 'none') {
                shippingType = 'shop';
            } else if ($('.card.shipping-recap').find('.selectedPickupPointRecap').css('display') !== 'none') {
                shippingType = 'pickup_point';
            } else if ($('.card.shipping-recap').find('.analyticsExpressShipping').data('is-express-shipping') === 'true') {
                shippingType = 'home_express';
            }
            localStorage.setItem('selectedShippingMethod', shippingType);
            _self.quickImpressionSender.pushFastPaymentClickInteraction(method, user);
        });
        $('body').on('analytics:changeFastShippingMethod', function (e, data) {
            let method = data.method;
            let user = 'guest';
            if (_self.helperData.frequentlyUser) {
                user = 'frequently_user';
            }
            _self.quickImpressionSender.pushChangeShippingFastInteraction(method, user);
        });
        $('body').on('click', '#apple-pay-btn', function (e) {
            if ($('.page').data('action') === 'Cart-Show') {
                $('body').trigger('analytics:paymentFastCheckout', {
                    method: 'apple_pay'
                });
            }
        });
        $('body').on('click', '#pickupPointMapBRT .store-gotomps-box a, #pickupPointPDB .store-gotomps-box a, #js-pickupPointMapBPOST .store-gotomps-box a', function (e) {
            let action = 'get_directions';
            let storeName = $(e.currentTarget).closest('div').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');

            _self.pushFindStoreClickResultAction(action, storeName, sku, 'shipping_method');
        });
        $('body').on('click', '#pickupPointMapBRT .js-choose-pickup-infowindow-BRT, #pickupPointListBRT .js-choose-pickupPointBRT', function (e) {
            let action = 'click_result_of_the_shops_listing';
            let storeName = _self.helper.formatString($(e.currentTarget).data('store-id'));
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');

            _self.pushFindStoreClickResultAction(action, storeName, sku, 'shipping_method');
        });

        $('body').on('click', '#pickupPointPDB .js-choose-pickupPointPDB, #pickupPointPDB .js-choose-pickup-infowindow-PDB', function (e) {
            let action = 'click_result_of_the_shops_listing';
            let storeName = _self.helper.formatString($(e.currentTarget).data('store-id'));
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');

            _self.pushFindStoreClickResultAction(action, storeName, sku, 'shipping_method');
        });

        $('body').on('click', '#pickupPointListBRT .fi-show-on-map-brt', function (e) {
            let action = 'view_in_map';
            let storeName = $(e.currentTarget).closest('.js-pickup-row').find('.js-pickup-name').text();
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');

            _self.pushFindStoreClickResultAction(action, _self.helper.formatString(storeName), sku, 'shipping_method');
        });
        $('body').on('click', '#pickupPointPDB .fi-show-on-map-PDB, #pickupPointBPOST .fi-show-on-map-BPOST', function (e) {
            let storeName = $(e.currentTarget).closest('.js-pickup-row').find('.js-pickup-name').text();
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');

            _self.pushFindStoreClickResultAction('view_in_map', _self.helper.formatString(storeName), sku, 'shipping_method');
        });
    }
}

const obj = new CheckoutFunnel();
module.exports = obj;
